import React from "react";
import { getTranslation } from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";

import Button from "../../../../../components/CustomButtons/Button";
import { Add } from "@mui/icons-material";

//Styles
import { withStyles } from "tss-react/mui";
import ButtonBarStyle from "./ButtonbarStyle";

function Buttonbar({ ...props }) {
  const { classes } = props;

  const buttons = [
    {
      color: "primary",
      label: getTranslation("vestigingen.form.custombuttons.buttonbar.label.menukaart", "Menukaart"),
      type: "menukaart",
    },
  ].map((value, key) => {
    return (
      <Button
        className={classes.middleButton}
        color={value.color}
        disabled={props.disableAll}
        key={key}
        onClick={() => props.onClick(value.type)}
        size={"sm"}
      >
        {value.label}
      </Button>
    );
  });

  return (
    <div className={classes.buttonGroup}>
      <Button className={classes.firstButton + " " + classes.plusButton} disabled justIcon size={"sm"}>
        <Add />
      </Button>
      {buttons}
    </div>
  );
}

export default withStyles(Buttonbar, ButtonBarStyle);
